import * as React from "react";
import { forwardRef } from "react";
const SvgApproved = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 10, fill: "#01C365" }), /* @__PURE__ */ React.createElement("path", { d: "M8 13L10.2857 15L16 10", stroke: "black", strokeWidth: 2, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgApproved);
export default ForwardRef;
